































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import ItemWithLink from '@/components/molecules/ItemWithLink.vue'
import ItemList from '@/components/organisms/ItemList.vue'
import { log } from '@/log'
import BehaviorConfig from '@/models/app-config/behavior/behavior'
import { ItemKind } from '@/models/item/kind'
import RecommendItemsService from '@/services/api/item/fku/recommend-items'

type State = NotInitializedStatus | InitializingStatus | SucceededStatus | FailedStatus

interface NotInitializedStatus {
  status: 'not_initialized'
}

interface InitializingStatus {
  status: 'initializing'
}

interface SucceededStatus {
  status: 'succeeded'
  /**
   * FIXME: ApiProductclass[]を返却したい
   * ItemList.vueとの互換の都合でany[]としている
   */
  items: any[]
}

interface FailedStatus {
  status: 'failed'
  errorMessage: string
}

@Component({
  components: {
    ItemList,
    ItemWithLink,
  },
})
export default class RecommendItems extends Vue {
  @Prop({ required: true })
  readonly fkuId: string

  @Prop({ required: true })
  readonly brandEnglishName: string

  state: State = {
    status: 'not_initialized',
  }

  get itemKind(): ItemKind {
    const behavior = BehaviorConfig.createFromBrand(this.brandEnglishName)

    return behavior.itemList.layout
  }

  get recommendItemService(): RecommendItemsService {
    return new RecommendItemsService()
  }

  onVisibilityChanged(isVisible: boolean) {
    if (isVisible && this.state.status === 'not_initialized') {
      this.loadRecommendItems()
    }
  }

  async loadRecommendItems() {
    this.state = { status: 'initializing' }

    const result = await this.recommendItemService.getRecommendItemsForDetail(this.fkuId, this.brandEnglishName)

    if (result.isRight()) {
      this.state = {
        status: 'succeeded',
        items: result.value,
      }
    } else {
      log.error('Failed to load recommend items', result.value)
      this.state = {
        status: 'failed',
        errorMessage: '商品情報の取得に失敗しました',
      }
    }
  }
}
